import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { userApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

const LOGINS_STALE_TIME = 5 * 60_000;

/** Rows per archive page — the navigator's page arithmetic depends on it. */
export const LOGIN_ARCHIVE_SIZE = 5000;

export function useAllUserLogins(archive: number) {
  return useQuery({
    queryKey: queryKeys.users.loginArchive(archive),
    queryFn: ({ signal }) =>
      userApiClient.getUsersLogins(
        archive,
        LOGIN_ARCHIVE_SIZE,
        toCancelToken(signal),
      ),
    placeholderData: keepPreviousData,
    staleTime: LOGINS_STALE_TIME,
    meta: { errorContext: 'user login history' },
  });
}
